module.exports = __webpack_public_path__ + "img/thumbnail_NileMonitor_f_normal.4ea1f7e9.png";